import styled, { css } from 'styled-components/macro';

import { textBlock } from '../../../styles/vars';

const imageQuote = css`
  width: calc(100% - 165px);
`;

const labelColorWhite = css`
  border-top: 1px solid #fff;
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;

  .quoteAuthor {
    ${props => props.hasImage && imageQuote}
  }

  .public-DraftEditor-content {
    ${({ colorScheme }) => `${textBlock(colorScheme)}`}
  }

  label::before {
    ${props => props.colorScheme === 'tag' && labelColorWhite}
  }
`;

export default Wrapper;
